<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body"  style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
         <AuthLogo />
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" style="max-width: 47%;"
                                                                                               :src="`${publicPath}app-assets/images/pages/illustration.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-white cursiveFont">Join Us Now!</h3>
                <h3 class="text-white cursiveFont">One payment solution for all your needs.</h3>
                <p class="text-white mb-0 ">Grow your business with us</p>
                <p class="text-white mb-0 ">Send and receive money with ease</p>
                <p class="text-white mb-0 ">Live tracking keeps you update on the go!</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Welcome to VaultsPay! 👋</h3>
                <p class="card-text mb-2">Please enter your email address and start the adventure</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" :validation-schema="schema">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" placeholder="Email" v-model="email" />
                    <ErrorMessage name="email" class="text-danger" />
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Send</Button>
                  </div>
                </form>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reCaptchaMixin from '@/mixins/reCaptchaMixin';
export default {
  mixins: [reCaptchaMixin],
  data(){
    return{
      loader: false,
      email: '',

    }
  },
  methods: {
    goToLogin(){
      this.$router.push({name: 'login'});
    },
    async sendCall(){

      let data ={
        "email": this.email,
      }

      if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
        try {
          const token = await this.executeRecaptcha('submit');
          this.recaptchaToken = token;

        } catch (error) {
          console.error('reCAPTCHA error:', error);
        }

        data = {
          ...data,
          verResponse: this.recaptchaToken,
          resId: Date.now()
        }
      }

      this.loader = true
      this.deleteAdminLoginCookie()
      this.makeRequest('post','v1/verify-email',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            localStorage.setItem('email',this.email);
            if(callResponse.response.data.data.otpVerification == 1){
              this.$router.push({name: 'verify-otp', params: { email: this.email }})
            }else{
              if(typeof(callResponse.response.data.data.accountExist) != 'undefined' &&  callResponse.response.data.data.accountExist == 1){
                this.$router.push({name: 'login', params: {email: this.email}});
              }else{
                this.$router.push({name: 'signup', params: {email: this.email}});
              }
            }
          }
        }

      });

    },
  },
}
</script>

